import React from 'react';
import { InputField } from 'components/form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import { OptionPricingTable } from './OptionPricingTable';
import { optionFormSchema, OptionFormValues } from '../../model';

interface Props {
  accountId: string;
  submitting?: boolean;
  submitLabel?: string;
  defaultValues: OptionFormValues;
  onCancel: () => void;
  onSubmit: (values: OptionFormValues) => void;
}

export const OptionForm = ({
  accountId,
  submitting = false,
  submitLabel = 'Save',
  defaultValues,
  onCancel,
  onSubmit,
}: Props) => {
  const form = useForm<OptionFormValues>({
    resolver: zodResolver(optionFormSchema),
    defaultValues,
  });

  return (
    <FormProvider {...form}>
      <Box component="form" onSubmit={form.handleSubmit(onSubmit)}>
        <Stack gap={2.5}>
          <Stack direction={{ xs: 'column', sm: 'row' }} gap={2}>
            <InputField control={form.control} name="code" label="Code" inputProps={{ variant: 'outlined' }} />
            <InputField control={form.control} name="name" label="Name" inputProps={{ variant: 'outlined' }} />
          </Stack>

          <InputField
            control={form.control}
            name="description"
            label="Description"
            inputProps={{ variant: 'outlined', multiline: true, minRows: 2 }}
          />

          <OptionPricingTable accountId={accountId} />

          <Stack direction="row" gap={1} justifyContent="flex-end">
            <Button variant="outlined" onClick={onCancel} disabled={submitting}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={submitting}>
              {submitLabel}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </FormProvider>
  );
};
